module.exports = __webpack_public_path__ + "21d4b9613b3516e3a3f347036c9fc251.svg";